module.exports = "<div> <group title=Default> <selector title=message :value.sync=selector1.value :options=selector1.options></selector> </group> <group title=Placeholder> <selector title=message :value.sync=selector2.value :placeholder=selector2.placeholder :options=selector2.options></selector> </group> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/demos/Selector.vue
 ** module id = 199
 ** module chunks = 0
 **/